import { arnInfo } from "../../integrations/resources/aws/util.ts";

export const accountIdToKey = (accountId: string) => `aws/${accountId}`;
export const serviceToKey = (accountId: string, service: string) =>
  `aws/${accountId}/${service}`;

export const resourcePatternToNodeKey = (
  pattern: string,
  accountId: string
) => {
  if (pattern === "*") return accountIdToKey(accountId);
  if (pattern.includes("*") || pattern.includes("?")) {
    let service: string | undefined;
    try {
      const { service: extractedService } = arnInfo(pattern);
      service = extractedService;
    } catch (error) {
      service = undefined;
    }
    const nodeKey = service
      ? serviceToKey(accountId, service)
      : accountIdToKey(accountId);
    return nodeKey;
  }
  return pattern;
};
